import { MenuItem } from 'primeng/api'

export function AiDeveloperActionsOptions(
  target: 'business-rule' | 'expression',
  config: {
    isReadonly: boolean
    isLoading: boolean
    canGenerateBusinessRule: boolean
    hasContent: boolean
    hasWarnings: boolean
  },
  actions: {
    onFixWarnings?: (params: any) => void
    onExplain?: () => void
    onGenerate?: () => void
  }
): MenuItem[] {
  const { isReadonly, isLoading, canGenerateBusinessRule, hasContent, hasWarnings } = config

  const iconStyles = 'flex justify-center items-center w-5 h-5 text-yellow-500'

  const isFixWarningsDisabled = !hasWarnings || isReadonly
  const fixWarningsTooltip = hasWarnings ? '' : 'No active warnings to fix'

  const fixWarningsOption: MenuItem = {
    label: 'Fix warnings',
    icon: `${iconStyles} ph ph-warning`,
    disabled: isLoading || isFixWarningsDisabled,
    tooltip: fixWarningsTooltip,
    command: (params: any): void =>
      actions.onFixWarnings ? actions.onFixWarnings(params) : undefined,
  }
  const explainOption: MenuItem = {
    label: 'Explain',
    icon: `${iconStyles} ph ph-info`,
    disabled: isLoading || !hasContent,
    command: (): void => (actions.onExplain ? actions.onExplain() : undefined),
  }

  const canGenerateExpressionOrBusinessRule =
    target === 'expression'
      ? hasContent
        ? !canGenerateBusinessRule
        : false
      : !canGenerateBusinessRule
  const generateOption: MenuItem = {
    label: hasContent && canGenerateBusinessRule ? 'Edit' : 'Generate',
    icon: `${iconStyles} ph ph-sparkle`,
    disabled: canGenerateExpressionOrBusinessRule || isLoading || isReadonly,
    command: (): void => (actions.onGenerate ? actions.onGenerate() : undefined),
  }

  switch (target) {
    case 'business-rule': {
      return [fixWarningsOption, explainOption, generateOption]
    }
    case 'expression': {
      return [fixWarningsOption, generateOption]
    }
    default: {
      return []
    }
  }
}

export function resetInputFileValueFromEvent(event: Event): void {
  const CLEAR_DELAY = 0
  const inputElement = event.target as HTMLInputElement

  setTimeout(() => (inputElement.value = ''), CLEAR_DELAY)
}

export function hasAiIconTarget(element: HTMLElement): boolean {
  const matchingSelector = 'flx-icon[name="stars-flowx-yellow"]'

  const children = Array.from(element.children)
  const getParents = (el: HTMLElement, parents = []): HTMLElement[] => {
    if (!el.parentElement) {
      return parents
    }

    return getParents(el.parentElement, [...parents, el.parentElement])
  }

  return (
    element.matches(matchingSelector) ||
    children.some((child) => child.matches(matchingSelector)) ||
    getParents(element).some((parent) => parent.matches(matchingSelector))
  )
}
